import axios from "axios";
import React, { createContext, useState, useEffect } from "react";
import { API_ENDPOINT } from "../utils/constants";
import { deleteToken, getHeader } from "../utils/util";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loggingOut, setLoggingOut] = useState(false); // Added loggingOut state

  const loadUser = async (showLoader = true) => {
    if (showLoader) setLoading(true);
    try {
      const { data } = await axios.get(
        `${API_ENDPOINT}/user/get-profile`,
        getHeader()
      );
      setUser(data);
    } catch (error) {
      console.error("Failed to load user", error);
      setUser(null);
    } finally {
      if (showLoader) setLoading(false);
    }
  };

  useEffect(() => {
    loadUser();
  }, []);

  const logoutUser = async () => {
    setLoggingOut(true);
    try {
      await axios.post(`${API_ENDPOINT}/user/logout`, {}, getHeader());
    } catch (error) {
      console.error("Failed to log out from server", error);
    } finally {
      // 1. You MUST delete the token locally to break the loop!
      deleteToken();

      setLoggingOut(false);

      // 2. Hard redirect to login to reset the router state
      window.location.href = "/login";
    }
  };

  const refreshUser = () => loadUser(false);

  return (
    <UserContext.Provider
      value={{
        user,
        loading,
        loggingOut, // Exposed to consumers
        reloadUser: () => loadUser(true),
        refreshUser,
        logoutUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
